import routerOptions0 from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/node_modules/.pnpm/nuxt@3.9.0_eslint@8.56.0_rollup@4.46.2_sass@1.69.4_stylelint@15.11.0_typescript@5.9.2_vite@5.0.10/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}